module.exports = __webpack_public_path__ + "media/images/checkout/challenger/unit_5x10-37fe9fbb842443a9021249b4a2cb1400.png";